import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8 12.1562H16M22 12.1562C22 17.6791 17.5228 22.1562 12 22.1562C6.47715 22.1562 2 17.6791 2 12.1562C2 6.6334 6.47715 2.15625 12 2.15625C17.5228 2.15625 22 6.6334 22 12.1562Z",
      stroke: "#23252C",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }